module.exports = __webpack_public_path__ + "static/media/pallet.38133bdc.svg";